import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

export interface TableState {
	quickFilter?: string;
	filterValue?: string;
	filterValue2?: string;
	first?: number;
	rows?: number;
	sortBy?: string | null;
	sortDir?: 'asc' | 'desc' | null;
	filterModel?: any;
	columnFilters?: Record<string, any>;
}

@Injectable({
	providedIn: 'root',
})
export class TableStateService {
	constructor(private _router: Router) {}

	getStorageKey(tableName?: string): string {
		const universityId = sessionStorage.getItem('university') || 'global';
		const schoolId = sessionStorage.getItem('school') || 'global';
		const name = tableName || this.normalizeRouteUrl(this._router.url);
		return `tableState_${universityId}_${schoolId}_${name}`;
	}

	private normalizeRouteUrl(url: string): string {
		if (!url) return 'default';
		return url.replace(/^\/+/, '').split('?')[0].split('#')[0].replace(/\//g, '_');
	}

	saveState(tableName: string | undefined, partialState: Partial<TableState>): void {
		const key = this.getStorageKey(tableName);
		const currentState = this.getState(tableName) || {};

		const newState: TableState = {
			...currentState,
			...partialState,
		};

		sessionStorage.setItem(key, JSON.stringify(newState));
	}

	getState(tableName?: string): TableState | null {
		const key = this.getStorageKey(tableName);
		const rawState = sessionStorage.getItem(key);
		if (!rawState) return null;

		try {
			return JSON.parse(rawState) as TableState;
		} catch (e) {
			return null;
		}
	}

	clearState(tableName?: string): void {
		const key = this.getStorageKey(tableName);
		sessionStorage.removeItem(key);
	}
}
